import React from 'react'
import { CartThumbnailRoot } from './styles'

const CartThumbnail = ({ image, ...props }) => {
  return <CartThumbnailRoot imageId={image.asset._ref || image.asset._id} {...props} />
}

export default CartThumbnail
